export class CachingPolicyException extends Error {

	constructor(type: string) {
		super(`Caching policy validation: ${type}.`);
		this.name = "CachingPolicyException";
	}
}
